import type { EventRegistration } from '../types';

export type RegistrationSort = 'newest' | 'oldest';

export interface RegistrationListFilters {
  paymentStatus?: string | null;
  source?: string | null;
  memberType?: string | null;
  q?: string | null;
}

/** Digits-only phone search, so `9940174017` matches `+919940174017`. */
function phoneQueryDigits(query: string): string | null {
  const compact = query.replace(/[\s()-]/g, '');
  if (!/^\+?\d{4,}$/.test(compact)) return null;
  return compact.replace(/\D/g, '');
}

export function filterRegistrations(
  rows: EventRegistration[],
  filters: RegistrationListFilters,
): EventRegistration[] {
  const q = filters.q?.trim().toLowerCase();
  const qDigits = q ? phoneQueryDigits(q) : null;
  return rows.filter((r) => {
    if (filters.paymentStatus && r.paymentStatus !== filters.paymentStatus) return false;
    if (filters.source && r.source !== filters.source) return false;
    if (filters.memberType && r.memberType !== filters.memberType) return false;
    if (q) {
      const hay = [r.name, r.phone, r.email, r.regNumber, r.lmNumber ?? ''].join(' ').toLowerCase();
      const phoneDigits = r.phone.replace(/\D/g, '');
      const matchesText = hay.includes(q);
      const matchesPhone = qDigits != null && phoneDigits.includes(qDigits);
      if (!matchesText && !matchesPhone) return false;
    }
    return true;
  });
}

export function parseRegistrationSort(value: string | null | undefined): RegistrationSort | null {
  if (value === 'newest' || value === 'oldest') return value;
  return null;
}

/** `null` keeps the incoming order (registration number). */
export function sortRegistrations(
  rows: EventRegistration[],
  sort: RegistrationSort | null | undefined,
): EventRegistration[] {
  if (sort !== 'newest' && sort !== 'oldest') return rows;
  return [...rows].sort((a, b) => {
    const byTime = a.createdAt < b.createdAt ? -1 : a.createdAt > b.createdAt ? 1 : 0;
    const cmp = byTime !== 0 ? byTime : a.seq - b.seq;
    return sort === 'oldest' ? cmp : -cmp;
  });
}
